import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import classNames from 'classnames';
import { ButtonAsA } from 'components/Button/ButtonAsA';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';
import './FileUploader.css';

interface Props {
  file: File;
  loading?: boolean;
  onRemoveFile: () => void;
}

export const FilePreview: FC<Props> = ({
  file,
  loading,
  onRemoveFile,
}: Props) => {
  const {
    generic: {
      components: {
        fileUploader: { filePreview: filePreviewMsg },
      },
    },
  } = useLocale();

  return (
    <div className='file-uploader__file-info'>
      <div className='file-uploader__file-title'>
        <Icon
          className={classNames(loading || 'text-green-400')}
          size='sm'
          iconStyle={loading ? 'regular' : 'solid'}
          glyph='fa-check-circle'
          loading={loading}
        />
        {file.name}
      </div>
      {loading ? (
        <span className='text-sm text-gray-400'>
          {filePreviewMsg.uploading}
        </span>
      ) : (
        <ButtonAsA type='button' onClick={onRemoveFile}>
          <span className='flex items-center gap-1 text-sm text-red-800'>
            <Icon glyph='fa-trash-can' size='sm' />
            {filePreviewMsg.delete}
          </span>
        </ButtonAsA>
      )}
    </div>
  );
};
